import axios from "axios";
import Cookies from "js-cookie";

import i18n from "@/i18n.js";
import router from "@/router";
import store from "@/store";
import { capitalize } from "@/functions";

var headers = {
  "Content-Type": "application/json; charset=utf-8",
  "X-CSRFToken": Cookies.get("csrftoken")
};

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL + "/api",
  timeout: 22000,
  headers: headers
});

export const cancelSource = axios.CancelToken.source();

// Intercept queries to inject bearer token, if needed
api.interceptors.request.use(
  (config) => {
    if (config.params === undefined) {
      config.params = {};
    }
    const token = localStorage.getItem("token");
    if (token !== null) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    // https://github.com/svrcekmichal/redux-axios-middleware/issues/83#issuecomment-407466397
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

function errorMessageFromData(data) {
  // Build a readable message from an API error payload:
  // {message}, {detail} or DRF field errors ({field: ["..."], non_field_errors: [...]})
  if (data === undefined || data === null) return undefined;
  if (typeof data === "string") return data;
  if (typeof data !== "object") return undefined;
  if (data.message !== undefined) return data.message;
  if (data.detail !== undefined) return data.detail;
  const parts = [];
  for (const [key, value] of Object.entries(data)) {
    let text;
    if (Array.isArray(value)) {
      text = value.join(" ");
    } else if (typeof value === "object" && value !== null) {
      text = JSON.stringify(value);
    } else {
      text = String(value);
    }
    parts.push(key === "non_field_errors" ? text : `${key}: ${text}`);
  }
  if (parts.length === 0) return undefined;
  return parts.join(" | ");
}

// Intercept expired token and renegociate it
api.interceptors.response.use(undefined, ( error ) => {
  if (error.response !== undefined) {
    if (error.response.status === 401) {
      if (error.response.config.url.includes("api/token")) {
        // Login errors are treated in Login.vue
        return Promise.reject(error.response.data);
      }
      return store.dispatch("to_login").then(() => {
        router.push({ name: "login" });
      });
    }
    var message = capitalize(
      i18n.global.t("error.default", { spec: error.response.statusText })
    );
    const data_message = errorMessageFromData(error.response.data);
    if (data_message !== undefined) {
      message = data_message;
    }
    store.dispatch("snackbar/showError", message);
    return Promise.reject(error.response.data);
  }

  var message_ = capitalize(i18n.global.t("error.unknown"));
  store.dispatch("snackbar/showError", message_);
  return Promise.reject(message_);
});

export { api };
